module.exports = __webpack_public_path__ + "static/blue-bg-4283e44d7dfa85772dfaaf86985c945a.png";